/**
 * Constantes para el módulo de Servicios
 */

export const SERVICE_STATUS = {
  PENDING: "PENDING",
  SCHEDULED: "SCHEDULED",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED",
  POSTPONED: "POSTPONED",
};

export const STATUS_COLORS = {
  [SERVICE_STATUS.PENDING]: "#fbc02d",
  [SERVICE_STATUS.SCHEDULED]: "#0288d1",
  [SERVICE_STATUS.IN_PROGRESS]: "#1976d2",
  [SERVICE_STATUS.COMPLETED]: "#43a047",
  [SERVICE_STATUS.CANCELLED]: "#e53935",
  [SERVICE_STATUS.POSTPONED]: "#8d6e63",
};

export const STATUS_LABELS = {
  [SERVICE_STATUS.PENDING]: "Pendiente",
  [SERVICE_STATUS.SCHEDULED]: "Programado",
  [SERVICE_STATUS.IN_PROGRESS]: "En curso",
  [SERVICE_STATUS.COMPLETED]: "Completado",
  [SERVICE_STATUS.CANCELLED]: "Cancelado",
  [SERVICE_STATUS.POSTPONED]: "Pospuesto",
};

export const SERVICE_TYPES = [
  { value: "MIP", label: "Servicio MIP" },
  { value: "TICKET", label: "Ticket" },
  { value: "NEBULIZACION", label: "Nebulizacion" },
  { value: "MICROINYECCION", label: "Microinyección" },
  { value: "MOSCA", label: "Mosca" },
  { value: "ABEJA", label: "Abeja" },
  { value: "EQUIPO", label: "Aplicación a Equipo" },
  { value: "CHOQUE", label: "Plan de Choque" },
  { value: "SUPERVISION", label: "Supervisión" },
  { value: "EVENTUAL", label: "Eventual" },
  { value: "OTRO", label: "Otro" },
];

export const FREQUENCY_TYPES = [
  { value: "UNICO", label: "Único" },
  { value: "MENSUAL", label: "Mensual" },
];

export const DEFAULT_FORM_VALUES = {
  client: "",
  branch: "",
  technicians: [],
  date: "",
  hour: "",
  type: "",
  status: SERVICE_STATUS.PENDING,
  notes: "",
  frequency: "",
  contactName: "",
  contactEmail: "",
  contactPhone: "",
};

